module.exports = __webpack_public_path__ + "69c80d9219acc8212929e98031dd2a27.svg";